
import React from 'react';
import Logo from './header/Logo';
import TopBar from './header/TopBar';
import DesktopNav from './header/DesktopNav';
import MobileNav from './header/MobileNav';
import { useAuth } from '@/hooks/auth/useAuth';
import { useIsMobile } from '@/hooks/use-mobile';

const Header: React.FC = () => {
  const { user, isDriver, signOut } = useAuth();
  const isMobile = useIsMobile();

  return (
    <header className="sticky top-0 z-40 w-full border-b bg-background/95 backdrop-blur-sm shadow-sm">
      <TopBar />
      
      <nav className={`${isMobile ? 'px-4' : 'container mx-auto px-4 md:px-6 lg:px-8'} flex items-center justify-between h-16 md:h-18`}>
        <Logo />
        <DesktopNav user={user} isDriver={isDriver} signOut={signOut} />
        <MobileNav user={user} isDriver={isDriver} signOut={signOut} />
      </nav>
    </header>
  );
};

export default Header;
